
import {apiEventserviceEndpoint} from '@/config/config.js';
import { createApiClientDefault } from "@/services/baseservice.js"

const baseservice = createApiClientDefault(apiEventserviceEndpoint)

export default {
    async getAll() {
        return await baseservice.get('/events',
        { baseURL: apiEventserviceEndpoint })
    },
    async getDetails(eventId) {
        return await baseservice.get('/events/' + eventId + "/details",
        { baseURL: apiEventserviceEndpoint })
    },
    async getRoomassignment(eventId) {
        return await baseservice.get('/events/' + eventId + "/room-assignment",
        { baseURL: apiEventserviceEndpoint })
    },
    async saveRoomAssignment(eventId, roomAssignmentRequest) {
        return await baseservice.put('/events/' + eventId + "/room-assignment/v2", roomAssignmentRequest,
        { baseURL: apiEventserviceEndpoint })
    },
    async update(eventId, event) {
        return await baseservice.put('/events/' + eventId, event,
        { baseURL: apiEventserviceEndpoint })
    },
    
    async addInstructor(eventId, instructor) {
        return await baseservice.put('/events/' + eventId + '/instructors/' + instructor, {},
        { baseURL: apiEventserviceEndpoint })
    },
    
    async removeInstructor(eventId, instructor) {
        return await baseservice.delete('/events/' + eventId + '/instructors/' + instructor, 
        { baseURL: apiEventserviceEndpoint })
    },
    async updateInstructorCourseAssignment(eventId, instructorCourseAssignment) {
        return await baseservice.post('/events/' + eventId + '/courseassignment', instructorCourseAssignment,
        { baseURL: apiEventserviceEndpoint })
    },
    async updateVolunteerAssignment(eventId, volunteerId, request) {
        return await baseservice.put('/events/' + eventId + '/volunteer-assignments/' + volunteerId, request,
        { baseURL: apiEventserviceEndpoint })
    },
};

